'use strict';
define('elements/disable-scroll',['jquery','utils/domready'], function($, domready) {
	domready(function() {
		var $navigationSwitch = $('.toggle--navigation'),
			$navigationCheckbox = $('#navigation-state'),
			$navigation = $('.navigation__main--wrap'),
			$pageBody = $('body'),
			offset;

		$navigation.on('click', 'a:not(.state ~ .navigation__link)', function() {
			$navigationCheckbox.prop('checked', false);
		});

		$navigationSwitch.click(function () {

			// inverted call
			if ($navigationCheckbox.prop('checked')) {
				$pageBody.removeClass('disable-scroll');
			} else {
				offset = $(document).scrollTop();
				$pageBody.addClass('disable-scroll');
			}
		});

		$pageBody.on('touchmove', function (e) {
			if ($navigationCheckbox.prop('checked')) {
				e.preventDefault();
			}
		});

		$navigation.on('touchmove', function (e) {
			if ($navigationCheckbox.prop('checked')) {
				e.stopPropagation();
				e.stopImmediatePropagation();
			}
		});
	});
});
